export const GLOBAL_LAYOUT_KEY = 'GlobalLayout';

export const SLOT_KEY = {
  SLOT_ADDITION_MENU: 'slotAdditionMenu', // Page Header
  SLOT_V_ADDITION_MENU: 'slotVAdditionMenu', // Page Header

  SLOT_TAB: 'slotTab', // Tab item on bar
  SLOT_CONTENT: 'slotContent', // Tab content

  SLOT_SCRIPTS: 'slotScripts', // Action hook (only scripting), Usage: Search "excuteMarketplaceScript" in BAU

  SLOT_SECTION: 'slotSection',
  SLOT_V_SECTION: 'slotVSection',

  SLOT_SECTION_ACTION: 'slotSectionAction',

  // Table column (slotTableColumn + ColumnName)
  SLOT_V_TABLE_COLUMN: 'slotVTableColumn',
  SLOT_V_STATIC_TABLE_COLUMN: 'slotVStaticTableColumn',
  SLOT_V_TABLE_TBODY: 'slotVTableTbody',

  // Static script (slotStaticScript + FunctionName)
  SLOT_STATIC_SCRIPT: 'slotStaticScript',

  // Form
  SLOT_LIST_GRID: 'slotListGrid',
  SLOT_RIGHT_SECTION_FORM: 'slotRightSectionForm',
  SLOT_MVC_FORM_SECTION: 'slotMvcFormSection',
  SLOT_MVC_FORM_INNER_SECTION: 'slotMvcFormInnerSection',
  SLOT_V_FORM_INNER_SECTION: 'slotVFormInnerSection',
  SLOT_V_FORM_SECTION: 'slotVFormSection',
  SLOT_V_LEFT_INNER_FORM_SECTION: 'slotVLeftInnerFormSection',
  SLOT_V_LEFT_FORM_SECTION: 'slotVLeftFormSection',
  SLOT_V_RIGHT_FORM_SECTION: 'slotVRightFormSection',
  SLOT_V_RIGHT_INNER_FORM_SECTION: 'slotVRightInnerFormSection',
  SLOT_V_FORM_SECTION_DIALOG: 'slotVFormSectionDialog',
  SLOT_V_LEFT_INNER_FORM_SECTION_DIALOG: 'slotVLeftInnerFormSectionDialog',
  SLOT_V_LEFT_FORM_SECTION_DIALOG: 'slotVLeftFormSectionDialog',
  SLOT_V_RIGHT_FORM_SECTION_DIALOG: 'slotVRightFormSectionDialog',
  SLOT_V_RIGHT_INNER_FORM_SECTION_DIALOG: 'slotVRightInnerFormSectionDialog',
  SLOT_V_FORM_FILTER: 'slotVFormFilter',
  SLOT_V_FORM_ADVANCED_FILTER: 'slotVFormAdvancedFilter',
  SLOT_SECTION_SUMMARY: 'slotSectionSummary',
};

export const listDirection = [
  { key: 'append', label: 'End' },
  { key: 'prepend', label: 'Start' },
  { key: 'custom', label: 'Custom (from start)' },
  { key: 'custom-end', label: 'Custom (from end)' },
  { key: 'replace-element', label: 'Replace Element' },
];

export const getRouteName = (module_name, action) => {
  return `${module_name} - ${action}`;
}
